//
//
//
//

export default {
  name: 'AppTitle',
  props: ['total'],
  data() {
    return {}
  },
  computed: {
    title() {
      const template = this.options.totalResultsTemplateText;
      if (!template || typeof template !== 'string') {
        return null;
      }
      if (!this.total || this.total === 0) {
        return ''
      }
      return template.replace('#{{total}}', this.total || ' ... ')
    }
  },
  methods: {}
}
